export default function Refunds() {
  return (
    <div className="max-w-[820px] mx-auto px-6 lg:px-12 py-14 lg:py-20" data-testid="refunds-page">
      <p className="overline mb-4">Policy</p>
      <h1 className="font-serif text-5xl md:text-6xl tracking-tight mb-10">Return &amp; Refund Policy.</h1>
      <div className="hairline mb-10" />

      <div className="text-charcoal text-[17px] md:text-[18px] leading-[1.75] space-y-6">
        <p>
          Our goal is simple: make sure every customer has a great experience. We prioritize
          replacements over refunds whenever possible, so you can actually try the product you ordered.
        </p>

        <div>
          <h2 className="font-serif text-2xl md:text-3xl tracking-tight mt-8 mb-3">Damaged Orders</h2>
          <p>
            If your order arrives damaged, send us a photo and we&rsquo;ll ship a replacement at no
            charge &mdash; no need to return anything.
          </p>
        </div>

        <div>
          <h2 className="font-serif text-2xl md:text-3xl tracking-tight mt-8 mb-3">Missing Items</h2>
          <p>
            If something is missing from your order, contact us and we&rsquo;ll make it right with a
            replacement shipment.
          </p>
        </div>

        <div>
          <h2 className="font-serif text-2xl md:text-3xl tracking-tight mt-8 mb-3">Opened Products</h2>
          <p>
            If you&rsquo;ve opened a product and it isn&rsquo;t what you expected, we&rsquo;ll send a
            replacement first. If you&rsquo;re still not satisfied after receiving it, we&rsquo;ll
            process a refund.
          </p>
        </div>

        <div>
          <h2 className="font-serif text-2xl md:text-3xl tracking-tight mt-8 mb-3">Unopened Products</h2>
          <p>
            If your product is unopened and you&rsquo;d like to return it, we&rsquo;ll provide a prepaid
            return label. Once return tracking shows movement, we&rsquo;ll process your refund &mdash;
            no need to wait for it to arrive back to us.
          </p>
        </div>

        <div>
          <h2 className="font-serif text-2xl md:text-3xl tracking-tight mt-8 mb-3">Late or Delayed Orders</h2>
          <p>
            If your order is delayed, we&rsquo;ll refund your shipping cost. The product is still on its
            way, so a shipping refund is the appropriate remedy for a delay.
          </p>
        </div>

        <div>
          <h2 className="font-serif text-2xl md:text-3xl tracking-tight mt-8 mb-3">Refund Timeline</h2>
          <p>
            Refunds typically take 5&ndash;10 business days to appear. If it&rsquo;s been 28+ days and
            you haven&rsquo;t received it, the processor likely had an issue &mdash; contact us and
            we&rsquo;ll send the refund manually via bank transfer (just your email address, no account
            needed).
          </p>
        </div>

        <div className="hairline my-12" />

        <p className="text-[15px] text-stone">
          Questions? Reach us at{" "}
          <a
            href="mailto:support@bulkbuykits.com"
            className="text-oxblood hover:text-charcoal underline"
            data-testid="refunds-support-email"
          >
            support@bulkbuykits.com
          </a>
          .
        </p>
      </div>
    </div>
  );
}
